<template>
    <div class="h-full relative p-6 lg:p-12">
        <div
            class="absolute inset-0 z-20 bg-gray-500/90 transition-opacity"
            v-if="!step2Complete"
        ></div>
        <div class="absolute inset-0 z-20" v-if="!step2Complete">
            <div class="absolute inset-0 z-20 w-100 overflow-y-auto">
                <div
                    class="flex min-h-full items-center justify-center p-4 text-center sm:p-0"
                >
                    <div
                        class="relative transform overflow-hidden rounded-lg bg-white dark:bg-slate-800 px-4 pb-4 pt-5 text-left shadow-xl dark:shadow-slate-900/50 transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6"
                    >
                        <div>
                            <div
                                class="mx-auto flex items-center justify-center"
                            >
                                <span class="fa-stack relative z-20 fa-lg">
                                    <i
                                        class="fa-solid fa-circle fa-stack-2x text-red-100"
                                    ></i>
                                    <i
                                        class="fa-regular fa-exclamation fa-stack-1x fa-inverse text-red-700"
                                    ></i>
                                </span>
                            </div>
                            <div class="mt-3 text-center sm:mt-5">
                                <h3
                                    class="text-base font-semibold leading-6 text-gray-900 dark:text-gray-100"
                                    id="modal-title"
                                >
                                    Go Back to the Previous Step
                                </h3>
                                <div class="mt-2">
                                    <p class="text-sm text-gray-500 dark:text-gray-400">
                                        You must complete the previous step
                                        before continuing.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!stepComplete" class="relative z-10">
            <div class="rounded-lg bg-white dark:bg-slate-800 p-6 shadow-lg dark:shadow-slate-900/50 mb-12">
                <h3 class="text-lg xl:text-xl font-semibold leading-6 mb-3">
                    Sit Tight
                    <span class="fa-stack relative z-20">
                        <i
                            class="fa-solid fa-circle fa-stack-2x text-orange-100"
                        ></i>
                        <i
                            class="fa-regular fa-timer fa-stack-1x fa-inverse text-orange-700"
                        ></i>
                    </span>
                </h3>
                <p class="text-base mb-3" v-if="step2?.cards[0].title">
                    It's been less than 30 days since you previously opened your
                    <span class="font-semibold">
                        {{ step2?.cards[0].title }}
                    </span>
                    <span class="font-light text-sm italic">
                        (Date Opened: {{ step2?.accounts[0].date_opened }}).
                    </span>
                </p>
                <p class="text-base mb-3">
                    Sit tight and wait for at least 30 days to pass, and then
                    you can proceed to Step 4 after
                    {{ step2?.thirty_days[0] }}.
                </p>
            </div>
            <img
                src="/images/companionpass/companionpass_wait30days.png"
                class="mx-auto mb-5 lg:mb-10"
                alt="My10X"
            />
        </div>
        <div v-if="stepComplete">
            <div class="rounded-lg bg-white dark:bg-slate-800 p-6 shadow-lg dark:shadow-slate-900/50 mb-12">
                <h3 class="text-lg xl:text-xl font-semibold leading-6 mb-3">
                    Step 3 Complete
                    <span class="fa-stack">
                        <i
                            class="fa-solid fa-circle fa-stack-2x text-green-100"
                        ></i>
                        <i
                            class="fa-regular fa-check fa-stack-1x fa-inverse text-green-700"
                        ></i>
                    </span>
                </h3>
                <p class="text-base mb-3">Your patience is paying off!</p>
                <p class="text-base mb-3">
                    It's been more than 30 days since you opened your
                    <span class="font-semibold">
                        {{ step?.cards[0].title }}
                    </span>
                    <span class="font-light text-sm italic">
                        (Date Opened: {{ step2?.accounts[0].date_opened }}).
                    </span>
                </p>
                <p class="text-base mb-3">
                    You're ready to start your next step!
                </p>
            </div>

            <img
                src="/images/companionpass/companionpass_wait30days.png"
                class="mx-auto mb-5 lg:mb-10"
                alt="My10X"
            />
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useCompanionPassStore } from '@/store/companionpass';

export default {
    name: 'StepThree',
    props: {},
    components: {},
    data: () => ({}),
    computed: {
        ...mapState(useCompanionPassStore, ['completeSteps']),
        stepContent() {
            return this.getStepContent(3);
        },
        step() {
            return this.getStep(3);
        },
        step2() {
            return this.getStep(2);
        },
        stepComplete() {
            return 3 in this.completeSteps ? true : false;
        },
        step2Complete() {
            return 2 in this.completeSteps ? true : false;
        },
        cdnUrl() {
            return window.cdnUrl;
        },
    },
    methods: {
        ...mapActions(useCompanionPassStore, ['getStep', 'getStepContent']),
    },
    mounted() {},
};
</script>
